import React from 'react';
import { useStaticQuery } from 'gatsby';
import { StyledH3 } from './h3.styled';
var H3 = function H3(_ref) {
    var stringText = _ref.stringText, color = _ref.color, customStyles = _ref.customStyles;
    var _useStaticQuery = useStaticQuery("830745958"), prismicStylesConfig = _useStaticQuery.prismicStylesConfig;
    return /*#__PURE__*/ React.createElement(StyledH3, {
        color: color,
        customStyles: customStyles,
        configStyles: prismicStylesConfig.data.h3_text_styles.text
    }, stringText);
};
export default H3;
